import { EventEmitter, Inject, Injectable, Output, PLATFORM_ID } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { base } from '../static/baseUrl';
import { catchError } from "rxjs/operators";
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { SocketService } from './socket.service';
@Injectable({
  providedIn: 'root'
})
export class ChatService {

  socket: any = null;
  @Output() outEven: EventEmitter<any> = new EventEmitter();
  public message$: BehaviorSubject<string> = new BehaviorSubject('');
  
  constructor(
    private http: HttpClient,
    private socketService: SocketService,

    @Inject(PLATFORM_ID) private platformId: Object

  ) {
      this.socket = this.socketService.connectOrGet();
      
  }




  emit(event: string, data: any) {
    this.socket.emit(event, data);
  }
  on(event: string) {
    return new Observable((subscriber) => {
      this.socket.on(event, (msg) => {
        subscriber.next(msg);
      });
    });
  }



  public getHisory = () => {
    if (isPlatformBrowser(this.platformId)) {
      return new Observable((subscriber) => {
        this.socket.on("history", (msg) => {
          subscriber.next(msg);
        });
      });
    }
  };




  createRoom(obj) {
    const url = `${base}/channel/getchannel`
    return this.http.post(url, obj)
  }


  ConnectUser(Id: any) {
    if (isPlatformBrowser(this.platformId)) {
      this.socket.emit('room', Id);
    }
  }

  public testMessages = () => {
    return new Observable((subscriber) => {
      this.socket.on("chat message", (msg) => {
        subscriber.next(msg);
      });
    });


  };




  public sendMessage(message) {
    if (isPlatformBrowser(this.platformId)) {
      this.socket.emit('chat message', message);

      this.getMessages(message.channelName)

    }
  }

  public getMessages = (converstationId) => {

    if (isPlatformBrowser(this.platformId)) {
      return Observable.create((observer) => {
        this.socket.on(`history${converstationId}`, (message) => {

          observer.next(message);
        });
      });
    }
  };




  public fetchHistory(data) {
    if (isPlatformBrowser(this.platformId)) {
      this.socket.emit('history', data);
    }
  }
  public deleteMessage(data) {
    if (isPlatformBrowser(this.platformId)) {
      this.socket.emit('d-status', data);
    }
  }
  public updateDeleteMessage = () => {
    if (isPlatformBrowser(this.platformId)) {
      return Observable.create((observer) => {
        this.socket.on('ud-status', (message) => {
          observer.next(message);
        });
      });
    }
  };

  public updateHistory = () => {
    if (isPlatformBrowser(this.platformId)) {
      return Observable.create((observer) => {
        this.socket.on('update-history', (message) => {
          observer.next(message);
        });
      });
    }
  };



  public removeConnection(data) {
    if (isPlatformBrowser(this.platformId)) {
      this.socket.emit('remove-connection', data);
    }
  }


  public updateConnection = () => {
    if (isPlatformBrowser(this.platformId)) {
      return Observable.create((observer) => {
        this.socket.on('update-connection', (data) => {
          observer.next(data);
        });
      });
    }
  };


  public markSoldEvent(data) {
    if (isPlatformBrowser(this.platformId)) {
      this.socket.emit('markSoldEvent', data);
    }
  }
  public soldTest = () => {
    if (isPlatformBrowser(this.platformId)) {
      return Observable.create((observer) => {
        this.socket.on('soldTest-event', (data) => {
          observer.next(data);
        });
      });
    }
  };

  public getNotifs = () => {
    if (isPlatformBrowser(this.platformId)) {
      return Observable.create((observer) => {
        this.socket.on('get-notification', (data) => {
          observer.next(data);
        });
      });
    }
  };

  public sendNotif(data) {
    if (isPlatformBrowser(this.platformId)) {
      this.socket.emit('new-notification', data);
    }
  }
  public readMessageStatus(data) {
    if (isPlatformBrowser(this.platformId)) {
      this.socket.emit('read-messageStatus', data);
    }
  }
  public readMessageStatusNew(data) {
    if (isPlatformBrowser(this.platformId)) {
      this.socket.emit('read-messageStatusNew', data);
    }
  }
  public verifyReadStatus = () => {
    if (isPlatformBrowser(this.platformId)) {
      return Observable.create((observer) => {
        this.socket.on('verify-readStatus', (data) => {
          observer.next(data);
        });
      });
    }
  };
  public showUserOnline = () => {
    if (isPlatformBrowser(this.platformId)) {
      return Observable.create((observer) => {
        this.socket.on('show-online', (data) => {
          observer.next(data);
        });
      });
    }
  };
  public showUserOffline = () => {
    if (isPlatformBrowser(this.platformId)) {
      return Observable.create((observer) => {
        this.socket.on('show-offline', (data) => {
          observer.next(data);
        });
      });
    }
  };

  public disconnectSocket = () => {
    if (isPlatformBrowser(this.platformId)) {
      return Observable.create((observer) => {
        this.socket.on('disconnect', (message) => {
          observer.next(message);
        });
      });
    }
  };

  public connect = () => {
    if (isPlatformBrowser(this.platformId)) {
      return Observable.create((observer) => {
        this.socket.on('connect', (message) => {
          observer.next(message);
        });
      });
    }
  };

  public addUser(newUser) {
    if (isPlatformBrowser(this.platformId)) {
      this.socket.emit('new-user', newUser);
    }
  }

  public removeUser(newUser) {
    if (isPlatformBrowser(this.platformId)) {
      this.socket.emit('user-offline', newUser);
    }
  }

  public showOnline(newUser) {
    if (isPlatformBrowser(this.platformId)) {
      this.socket.emit('user-online', newUser);
    }
  }
  public showOffline(newUser) {
    if (isPlatformBrowser(this.platformId)) {
      this.socket.emit('user-offline', newUser);
    }
  }

  public sendMessageEvent(eventName, message) {
    if (isPlatformBrowser(this.platformId)) {
      this.socket.emit(eventName, message);
    }
  }
  public fileUploadEvent(message) {
    if (isPlatformBrowser(this.platformId)) {
      this.socket.emit('file-uploaded', message);
    }
  }



  fetch_history = (user) => {
    let headers = new HttpHeaders();
    return this.http.get(URL + 'chat/fetch_history_count?email=' + user.email, {
      headers: headers,
    });
  };

  put(body, path) {
    let headers = new HttpHeaders();
    return this.http.put(URL + path, body, {
      headers: headers,
    });
  }

  get(path) {
    return this.http.get(URL + path);
  }

  public user_list = (id: string) => {
    let headers = new HttpHeaders();
    return this.http.get(URL + 'chatUser?id=' + id, {
      headers: headers,
    });
  };
  public deleteUserMessage(data) {
    let headers = new HttpHeaders();
    return this.http.post(URL + 'chat/delete/message', data, {
      headers: headers,
    });
  }

  postFile(fileToUpload: File, to, from, img) {

    const endpoint = URL + 'chat/uploadfile';
    const formData: FormData = new FormData();
    formData.append('attachment', fileToUpload, fileToUpload.name);
    formData.append('to', to), formData.append('from', from);
    formData.append('img', img);
    return this.http
      .post(endpoint, formData, {
        reportProgress: true,
        observe: 'events',
      })
      .pipe(catchError(this.errorMgmt));
  }

  errorMgmt(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }



}




